import api from './api';

export interface ConversionEffects {
  direction: 'to-drop' | 'to-live-load';
  routeNodesAfter: number;
  orderTypeChange: { from: string; to: string; orderNumber: string; affectsTasks: number } | null;
  salaryRecalculated: boolean;
  /** to-drop only */
  removesReturnNode?: boolean;
  createsFollowUpTask?: boolean;
  /** At empty/loaded the trip is over — converting also completes the task. */
  autoCompletes?: boolean;
  /** to-live-load only */
  addsReturnNode?: boolean;
  removesFollowUpTask?: boolean;
}

export interface ConversionOptions {
  taskDbId: number;
  taskId: string;
  status: string;
  effectiveStatus: string;
  currentSubtype: 'live-load' | 'drop';
  targetSubtype: 'live-load' | 'drop';
  /** Optimistic-lock token — send it back on convert so a stale screen is rejected. */
  stateVersion: number;
  canConvert: boolean;
  blockedReasons: string[];
  effects: ConversionEffects;
}

export interface ConversionResult {
  taskId: string;
  taskDbId?: number;
  fromSubtype?: string;
  toSubtype?: string;
  routeNodeCount?: number;
  orderChanged?: { orderNumber: string; from: string; to: string } | null;
  removedFollowUpTasks?: string[];
  warehouseAppointmentsRetyped?: number;
  salaryResynced?: boolean;
  autoCompleted?: boolean;
  alreadyConverted?: boolean;
  currentSubtype?: string;
}

export const taskTypeChangeApi = {
  async getConversionOptions(taskId: number): Promise<ConversionOptions> {
    const response = await api.get(`/task-type/${taskId}/conversion-options`);
    return response.data;
  },

  /** Direction is inferred server-side; targetSubtype guards against a stale screen. */
  async convert(
    taskId: number,
    payload: { reason: string; targetSubtype?: 'live-load' | 'drop'; expectedVersion?: number }
  ): Promise<ConversionResult> {
    const response = await api.post(`/task-type/${taskId}/convert`, payload);
    return response.data;
  },
};

export default taskTypeChangeApi;
